export default {"src":"/_next/static/media/positionOpposition.9bba2018.svg","height":400,"width":401,"blurWidth":0,"blurHeight":0};